import { render, staticRenderFns } from "./AuthDetail.vue?vue&type=template&id=2777024e&scoped=true"
import script from "./AuthDetail.vue?vue&type=script&lang=js"
export * from "./AuthDetail.vue?vue&type=script&lang=js"
import style0 from "./AuthDetail.vue?vue&type=style&index=0&id=2777024e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777024e",
  null
  
)

export default component.exports